import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { InputSelect } from '@/components';
import { useClientTerminology } from '@/views/list/NetworkTerms';
import type { FilterState } from '@/features/filterSlice';
import { getRatingOptions } from '@/views/filter/utils';
import { Rating } from '@/features/types';

export const EncroachmentRiskFilter = (props: {
  control: Control<FilterState>;
}) => {
  const intl = useClientTerminology();
  const encroachmentRatings = getRatingOptions(Rating);

  return (
    <Controller
      control={props.control}
      name="encroachmentRatings"
      render={({ field: { onChange, onBlur, value } }) => {
        return (
          <InputSelect
            isMulti
            label={intl.formatMessage({ id: 'filter.encroachmentRiskLabel' })}
            placeholder={intl.formatMessage({
              id: 'filter.encroachmentRiskPlaceholder',
            })}
            options={encroachmentRatings}
            onChange={onChange}
            onBlur={onBlur}
            value={encroachmentRatings.filter((c) => value.includes(c.value))}
          />
        );
      }}
    />
  );
};
